import React, {Component} from 'react';
import '../../styles/Home.css'
import Footer from "../../shared/Footer";
import AplikacjaMobilna from "./AplikacjaMobilna";
import Newsletter from "./Newsletter";
import RegulaminPrzewozow from "./regulaminComponents/RegulaminPrzewozow";
import AdminPlikiService from "../../admin/adminComponents/AdminPlikiService";

export default class Regulaminy extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showReg: this.props.showReg,
            loading: true
        }
    }

    componentDidMount() {
        AdminPlikiService.getPlik('polityka-prywatnosci')
            .then(function (response) {
                this.setState({polityka: response.data})
            }.bind(this)).catch(err => {
            console.log(err)
        }).then(() => {
            AdminPlikiService.getPlik('warunki-przewozu')
                .then(function (res) {
                    this.setState({loading: false, warunki: res.data});
                    console.log(res)
                }.bind(this)).catch(err => {
                console.log(err)
            })
        })
    }

    render() {
        return <div>
            <div className="wynajemNaglowek przerywnik">
                <div className="container text-center">
                    <h2><b>Nasza działalność opiera się na jasnych zasadach. </b></h2>
                    <h4>Poniżej zamieszczamy dokumenty, które regulują funkcjonowanie naszej firmy oraz serwisu
                        www.</h4>
                </div>
            </div>
            {this.state.showReg ? <RegulaminPrzewozow/> : <div className="panelPaddingMobilka" style={{
                background: '#f9f9f9',
                paddingTop: '15px',
                paddingBottom: '15px'
            }}>
                <div className="container" style={{background: '#fff', padding: 0}}>
                    <div className="aktualnosci ramka wynik">
                        {this.state.loading ? null : <div className="row">
                            <div className="col-sm-12 text-center" style={{paddingTop: 75}}>
                                <h2 style={{fontWeight: 'bold'}}>Regulaminy</h2>
                                <hr/>
                                <div className="row text-left">
                                    <div className="col-sm-1"/>
                                    <div className="col-sm-11" style={{
                                        lineHeight: 2.5,
                                        fontSize: '1.25rem',
                                        fontWeight: 'bold',
                                        marginTop: 50
                                    }}>
                                        <a href={this.state.warunki.get}>
                                            <i className="fa fa-check-square"
                                               style={{color: 'green'}}/> {this.state.warunki.opis}</a>
                                    </div>
                                    <div className="col-sm-1"/>
                                    <div className="col-sm-11" style={{
                                        lineHeight: 2.5,
                                        fontSize: '1.25rem',
                                        fontWeight: 'bold',
                                        marginBottom: 50
                                    }}>
                                        <a href={this.state.polityka.get}><i
                                            className="fa fa-check-square"
                                            style={{color: 'green'}}/> {this.state.polityka.opis}</a>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>}
            {/*<AplikacjaMobilna/>*/}
            {/*<Newsletter/>*/}
            <Footer/>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/Regulaminy.js